export default __webpack_public_path__ + "static/media/Websites-Camera 1.a3fd98e4.png";